export const globals = {
  MuiCssBaseline: {
    "@global": {
      "@font-face": "Inter",
      html: {
        fontSize: 16,
        htmlFontSize: 16
      }
    }
  } as any
};
